import { faDollarSign } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * OpenPayment item interface for ui_metadata storage
 */
export interface OpenPaymentItem {
  id: string;
  displayLabel: string;
  name: string;
}

/**
 * Transform API response to OpenPaymentItem format
 */
export const transformOpenPayment = (apiItem: {
  id: string | number;
  name: string;
}): OpenPaymentItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.name,
  name: apiItem.name,
});

/**
 * Modal configuration for OpenPayment selector
 */
export const openPaymentModalConfig: GenericSelectorModalConfig<OpenPaymentItem> = {
  title: 'Select Open Payments Company',
  searchPlaceholder: 'Search open payments companies...',
  emptyStateIcon: faDollarSign,
  emptyStateMessage: 'No company selected',
  noResultsMessage: (searchTerm) => `No companies found for "${searchTerm}"`,
  colorTheme: 'amber',
  selectionMode: 'single',
  showConnectorToggle: false,
  defaultConnector: 'ANY',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'company',
  itemLabelPlural: 'companies',
};

/**
 * Node display configuration for OpenPayment
 */
export const openPaymentNodeConfig: GenericNodeComponentConfig<OpenPaymentItem> = {
  colorTheme: 'amber',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  maxVisibleItems: 1, // Single selection
  showConnectorLabel: false,
};
